import { createFileRoute, Outlet } from '@tanstack/react-router'

function AuditorAuditEvidenceRouteLayout() {
  return (
    <div className='overflow-hidden'>
      <Outlet />
    </div>
  )
}

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/audit-evidence',
)({
  component: AuditorAuditEvidenceRouteLayout,
})
